import React,{FC, useEffect} from "react";
import { useMarket } from "../../api/hooks/useMarket";


const MarketUpdater: FC = (): null => {
    const marketFunc = useMarket();

    useEffect(() => {
        //gets token IDs and stores them in redux
       //marketFunc.getIDs();
    }, [])

    return null
}

export default MarketUpdater;